/**
 *
 * @param { value: valueToValidate, message: 'CustomErrorMessage' } opts
 * @returns { valid: true/false, messages: Array}
 */
export default class RequiredValidator {
	constructor(opts) {
		this.validateOn = 'change';

		if (opts) {
			this.customMessage = opts.message;
			this.allowWhitespace = true;

			if (opts.validateOn) {
				this.validateOn = opts.validateOn;
			}
		}

		this.defaultMessage = 'Field cannot be blank.';
		this.result = { valid: true };
	}

	onlyWhitespace(value) {
		let result = false;

		if (
			value !== undefined &&
			typeof value === 'string' &&
			value.replace(/\s/g, '').length === 0
		) {
			result = true;
		}

		return result;
	}

	validate(value) {
		this.result.valid = true;
		this.value = value;

		if (
			this.value === undefined ||
			this.value === null ||
			this.value === '' ||
			this.onlyWhitespace(value)
		) {
			this.result.valid = false;
		}

		if (typeof this.value === 'string' && this.value.trim().length === 0) {
			this.result.valid = false;
		}

		if (!this.result.valid) {
			if (this.customMessage) {
				this.result.messages = [this.customMessage];
			} else {
				this.result.messages = [this.defaultMessage];
			}
		}

		return this.result;
	}
}
